export const ProjectWorkspaceFileCategory = {
  CONTRACT: 'CONTRACT',
  SCOPE: 'SCOPE',
  REPORTS: 'REPORTS',
  DATA: 'DATA',
  OTHER: 'OTHER',
} as const;

export type ProjectWorkspaceFileCategory =
  (typeof ProjectWorkspaceFileCategory)[keyof typeof ProjectWorkspaceFileCategory];

export const ProjectWorkspaceFileCategoryValues = Object.values(ProjectWorkspaceFileCategory);

export interface ProjectWorkspaceFileActorDto {
  id: string;
  displayName: string;
}

export interface ProjectWorkspaceFileDto {
  id: string;
  projectId: string;
  category: ProjectWorkspaceFileCategory;
  originalName: string;
  mimeType: string;
  size: number;
  isImmutable: boolean;
  uploadedAt: string;
  uploadedBy: ProjectWorkspaceFileActorDto;
}

export const ProjectWorkspaceFileActivityKind = {
  UPLOADED: 'uploaded',
  DELETED: 'deleted',
} as const;

export type ProjectWorkspaceFileActivityKind =
  (typeof ProjectWorkspaceFileActivityKind)[keyof typeof ProjectWorkspaceFileActivityKind];

export interface ProjectWorkspaceFileActivityDto {
  fileId: string;
  kind: ProjectWorkspaceFileActivityKind;
  category: ProjectWorkspaceFileCategory;
  originalName: string;
  at: string;
  actor: ProjectWorkspaceFileActorDto;
}
